import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";

import { EnquiryTextProps } from "../types";

const EnquiryText = ({ primaryText, linkText, ...props }: EnquiryTextProps) => {
    const { gray900 } = colors;

    return (
        <div
            css={css({
                color: gray900,
                fontSize: "14px",
                fontWeight: 600,
                letterSpacing: "0.1px",
                marginTop: "16px"
            })}
        >
            <span>{primaryText} </span>

            <TextLink {...props} size={TEXT_LINK_SIZES.Normal}>
                {linkText}
            </TextLink>
        </div>
    );
};

export default EnquiryText;
